import { BMDivider } from "@traveloka/district-bloom";
import { useTravelerPickerContextV2 } from "../../../../providers/TravelerPickerContextV2";
import TravelerPickerSelectEmployee from "./TravelerPickerSelectEmployee";
import TravelerPickerSelectNonEmployee from "./TravelerPickerSelectNonEmployee";

type Props = {
  testID?: string;
};

export default function TravelerPickerContent(props: Props) {
  const {
    permissions: {
      travelerPicker: { canBookNonEmployee, canBookForOthers },
    },
  } = useTravelerPickerContextV2();

  return (
    <>
      {canBookForOthers && <TravelerPickerSelectEmployee />}
      {canBookForOthers && canBookNonEmployee && <BMDivider type="SUBTLE" />}
      {canBookNonEmployee && <TravelerPickerSelectNonEmployee />}
    </>
  );
}
